import React from "react";
import { useLocation } from "react-router-dom";
import { Carousel } from "react-bootstrap"; 
import {
  FaShieldAlt,
  FaLock,
  FaBug,
  FaCloud,
  FaDesktop,
  FaExclamationTriangle,
  FaCode,
  FaClipboardCheck,
  FaAddressCard,
  FaFileContract,
} from "react-icons/fa";

const Services = () => {
  const location = useLocation();

  const services = [
    { icon: <FaAddressCard size={40} />, heading: "Identity & Access Management", content: "IGA, SSO, MFA, PAM" },
    { icon: <FaFileContract size={40}  />, heading: "Compliance & Regulatory Requirements", content: "ISO 27001, 27017, 42001 (AIMS)" },
    { icon: <FaBug size={40} />, heading: "Endpoint Security", content: "Antivirus, Device Monitoring, Mobile Protection" },
    { icon: <FaCode size={40} />, heading: "Security Operations (SOC)", content: "24/7 support, incident response, and disaster recovery" },
    { icon: <FaClipboardCheck size={40} />, heading: "Network Security", content: "Firewall management, IDS/IPS, VPN services, Router, NAC" },
    { icon: <FaCloud size={40} />, heading: "Cloud Security", content: "Cloud service protection, Compliance management, Cloud security audits, Cloud Security Posture Management (CSPM)" },
    { icon: <FaDesktop size={40} />, heading: "Threat Detection", content: "Utilizes tools like EDR, NDR and AI-driven solutions to continuously monitor and analyze systems, networks, and endpoints for suspicious activities." },
    { icon: <FaExclamationTriangle size={40} />, heading: "Security Awareness Training", content: "Develop a Security Awareness program in alignment with organization policies and conduct Security Awareness Training and Phishing Campaign" },
    { icon: <FaLock size={40} />, heading: "Data Protection", content: "Ensures the confidentiality, integrity, and availability of sensitive data through encryption, access controls, and secure data management practices" },
    { icon: <FaShieldAlt size={40} />, heading: "Security Assurance", content: "Identifies, evaluates, and exploits security vulnerabilities in systems and networks to strengthen defenses and enhance overall security posture." },

  ];

  const chunkSize = 5; 
  const serviceChunks = [];
  for (let i = 0; i < services.length; i += chunkSize) {
    serviceChunks.push(services.slice(i, i + chunkSize));
  }

  return (
    <>
      <div className="monitor">
        <div className="code-line">Our Services...</div>
      </div>

      <section className="services-section smooth" href="service">
        <div className="container serviceTop">
          <div className="row col-12 columnService">
            <div className="col-3 custom-col"></div>
            <div className="col-9 d-flex flex-column pt-3 columnService">
              <Carousel indicators={false} interval={2000} controls={true}>
                {serviceChunks.map((chunk, slideIndex) => (
                <Carousel.Item key={slideIndex}>
                <div className="d-flex justify-content-center w-100">
                  <div className="services-grid">
                    {chunk.map((service, index) => (
                      <div className="service-card mx-3" key={`${slideIndex}-${index}`}>
                        <div className="icon-container">{service.icon}</div>
                        <h3 className="service-heading">{service.heading}</h3>
                        <p className="service-content">{service.content}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
